import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const STICKYBLOCK_LEGACY_FIELD_ORDER = [
  "position",
  "gap"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  stickyBlockDescriptor: _generatedStickyBlockDescriptor,
  stickyBlockBlocDefinition,
  stickyBlockDashboardLayout,
  stickyBlockConfig,
  stickyBlockResolveConfig,
  stickyBlockProperties,
} = doodBlockConfig(
  {
    name: "Sticky block",
    componentType: 'StickyBlockComponent',
    category: 'content',
    description: "Sticky block.",
    keywords: [],
    sharedFields: {}
,
    slots: [
      {
        key: 'body',
        name: "pages.blocks.sticky.body.label",
        accept: 'explicitOnly',
        allowedTypes: [".*(?<!Page)"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    position: propertyValue({
      type: 'select',
      value: "top",
      options: {
        label: "pages.blocks.sticky.position.label",
        multiple: false,
        choices: [
          {
            value: "top",
            label: "pages.blocks.sticky.position.options.top",
          },
          {
            value: "bottom",
            label: "pages.blocks.sticky.position.options.bottom",
          }
        ]
      }
    }),
    gap: propertyValue({
      type: 'text',
      value: "0",
      options: {
        label: "pages.blocks.sticky.gap.label",
        help: "pages.blocks.sticky.gap.help",
        value: "0"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.sticky.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.sticky.fieldset.placement.label",
            fields: ["body", "position", "gap"],
          },
        ],
      },
    ],
  })
);

export function stickyBlockDescriptor(): IBlockDescriptor;
export function stickyBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function stickyBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedStickyBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedStickyBlockDescriptor, stickyBlockProperties, fieldOrder);
}

export {
  stickyBlockBlocDefinition,
  stickyBlockDashboardLayout,
  stickyBlockProperties,
  stickyBlockConfig,
  stickyBlockResolveConfig,
};

export type StickyBlockConfig = typeof stickyBlockConfig;
